import { SecondaryButton } from '@euler/app/flows/ai-suite/components/PrimaryButton';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { kBiNewDashboardName } from '@euler/model/bi/answer';
import { kBiMaxDashboardName } from '@euler/model/bi/dashboard';
import { memo, useState } from 'react';
import { TextInput, View } from 'react-native';

/** The new dashboard's name; left empty it is called 新看板. */
export const NewDashboardForm = memo(
  ({
    disabled,
    onCancel,
    onCreate,
  }: {
    disabled: boolean;
    onCancel: () => void;
    /** Blank: the server's default new name. */
    onCreate: (name: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const [name, setName] = useState('');
    const submit = () => {
      if (!disabled) onCreate(name.trim());
    };
    return (
      <View style={{ gap: rpx(8) }}>
        <TextInput
          accessibilityLabel="新看板名称"
          value={name}
          onChangeText={setName}
          onSubmitEditing={submit}
          maxLength={kBiMaxDashboardName}
          placeholder={`看板名称，默认「${kBiNewDashboardName}」`}
          placeholderTextColor={aiColors.mutedForeground}
          autoFocus
          returnKeyType="done"
          style={{
            height: rpx(40),
            paddingHorizontal: rpx(12),
            borderRadius: rpx(10),
            borderWidth: 1,
            borderColor: aiColors.border,
            backgroundColor: aiColors.input,
            color: aiColors.foreground,
            fontSize: rpx(14),
          }}
        />
        <View style={{ flexDirection: 'row', gap: rpx(8) }}>
          <SecondaryButton title="取消" onPress={onCancel} />
          <SecondaryButton
            title="新建并添加"
            disabled={disabled}
            onPress={submit}
          />
        </View>
      </View>
    );
  },
);
